import { ApiType } from "@gymflow/common";
import { TokenPageableRequestParams } from "@gymflow/types";
import { useInfiniteQuery } from "@tanstack/react-query";

import { smsQueryKeys } from "./smsQueryKeys";

export const useInfiniteQueryCreditsHistorySpent = ({
  api,
  params,
  refetchOnWindowFocus = false,
  enabled,
}: {
  api: ApiType;
  params: TokenPageableRequestParams;
  refetchOnWindowFocus?: boolean;
  enabled: boolean;
}) => {
  return useInfiniteQuery({
    queryKey: smsQueryKeys.getCreditsHistorySpent(params),
    queryFn: async ({ pageParam }: { pageParam?: string }) =>
      (
        await api.smsApi.getCreditsHistorySpent({
          ...params,
          nextPageToken: pageParam,
        })
      ).data,
    getNextPageParam: (lastPage) => lastPage?.nextPageToken,
    refetchOnWindowFocus,
    initialPageParam: undefined,
    enabled,
  });
};
